import React from "react";
import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";

const TechnologieCard = ({ techno }) => {
  // console.log("TECHNO:", techno);

  return (
    <div className="bg-white shadow-md border rounded-2xl p-6 w-full max-w-lg h-full flex flex-col justify-between">
      <div className="text-orange-500 mb-3">
        <HelpCircle size={24} />
      </div>

      {/* Utilise techno.name à la place de techno.title */}
      <h2 className="text-lg font-bold my-4">{techno.name}</h2>

      {/* Description temporaire (car techno.description n'existe pas encore) */}
      <p className="text-gray-500 mb-5 leading-snug">
        {techno.description || "Aucune description disponible."}
      </p>

      <Link
        to={`/quizz/${techno.id}`} // Correction pour mettre l'id réel dans le lien
        className="inline-block border border-black text-black font-medium py-2 px-6 rounded-full hover:bg-[#FF9800] hover:border-none transition w-full text-center no-underline"
      >
        Débuter
      </Link>
    </div>
  );
};

export default TechnologieCard;
